import { useEffect, useState } from "react";
import { Robot, X } from "@phosphor-icons/react";

const TYPEBOT_URL = "https://chat.tecnointerativa.com.br/caminhosapp";

export default function AIAssistantButton() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="ai-assistant-button"
        aria-label="Abrir atendente de IA"
        title="Atendente de IA"
        className="fixed bottom-6 right-6 z-50 group flex items-center gap-2 h-14 pl-3.5 pr-5 rounded-full text-white font-bold shadow-[0_10px_30px_rgba(30,95,255,0.35)] hover:shadow-[0_16px_40px_rgba(30,95,255,0.5)] hover:-translate-y-1 transition-all"
        style={{ background: "linear-gradient(135deg, #1E5FFF 0%, #002FA7 100%)" }}
      >
        <span className="relative flex items-center justify-center w-9 h-9 rounded-full bg-white/20">
          <span className="absolute inset-0 rounded-full bg-white/25 animate-ping" />
          <Robot size={22} weight="fill" />
        </span>
        <span className="hidden sm:inline text-sm">Atendente IA</span>
      </button>

      {open && (
        <div
          data-testid="ai-assistant-overlay"
          className="fixed inset-0 z-[60] bg-black/40 backdrop-blur-sm flex items-end sm:items-center sm:justify-end"
          onClick={() => setOpen(false)}
        >
          <div
            role="dialog"
            aria-label="Atendente de IA"
            onClick={(e) => e.stopPropagation()}
            className="relative bg-white shadow-2xl w-full h-[85vh] sm:h-[600px] sm:max-h-[80vh] sm:w-[400px] sm:mr-6 sm:mb-24 rounded-t-2xl sm:rounded-2xl overflow-hidden flex flex-col"
          >
            <div
              className="flex items-center justify-between px-4 h-12 flex-shrink-0"
              style={{ background: "linear-gradient(135deg, #1E5FFF 0%, #002FA7 100%)" }}
            >
              <div className="flex items-center gap-2 text-white">
                <Robot size={18} weight="fill" />
                <span className="text-sm font-bold">Atendente IA</span>
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                data-testid="ai-assistant-close"
                aria-label="Fechar atendente de IA"
                className="w-8 h-8 rounded-full hover:bg-white/20 flex items-center justify-center text-white"
              >
                <X size={16} weight="bold" />
              </button>
            </div>
            <iframe
              src={TYPEBOT_URL}
              title="Atendente de IA — Caminhos APP"
              className="flex-1 w-full border-0"
              allow="microphone; clipboard-write"
            />
          </div>
        </div>
      )}
    </>
  );
}
